import objectHash from 'object-hash'
import {pickAll} from 'ramda'

import {UrlCheckoutParamsType} from '@daedalus/core/src/utils/url/types/UrlParams'

const getHotelPagesSearchId = (urlParams: UrlCheckoutParamsType) => {
  const searchData = pickAll(
    [
      'checkIn',
      'checkOut',
      'currency',
      'userIp',
      'anonymousId',
      'deviceType',
      'locale',
      'rooms',
      'hotelId',
      'userCountry',
      'redirectId',
      'userAgent'
    ],
    urlParams
  )

  return objectHash(searchData)
}

export default getHotelPagesSearchId
